import React, { Component } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import EventEmitter, { Events } from "../../services/eventemitter";
import { t } from "i18next";

// import Cookies from "universal-cookie";

import bgImg1 from "../../assets/img/sidebar-bg/01.jpg";
import bgImg2 from "../../assets/img/sidebar-bg/02.jpg";
import bgImg3 from "../../assets/img/sidebar-bg/03.jpg";
import bgImg4 from "../../assets/img/sidebar-bg/04.jpg";
import bgImg5 from "../../assets/img/sidebar-bg/05.jpg";
import bgImg6 from "../../assets/img/sidebar-bg/06.jpg";
import { cookieService } from "../../services/CookieService";

const circleStyle = {
    width: "20px",
    height: "20px",
};

interface CustomizerState {
    customizer: boolean;
    darklayout: boolean;
    compactMenu: boolean;
}

// const cookies = new Cookies();

interface CustomizerProps {
    handleSidebarSize: (size: string) => void;
    handleLayout: (layout: string) => void;
    handleCollapsedSidebar: (state: boolean) => void;
    sidebarBgColor: (color: string) => void;
    sidebarImageUrl: (imgurl: string) => void;
}

class Customizer extends Component<CustomizerProps, CustomizerState> {
    constructor(props) {
        super(props);

        this.state = {
            customizer: false,
            darklayout: false,
            compactMenu: true,
        };

        EventEmitter.on(Events.toggleCustomizer, this.toggleCustomizer);
        EventEmitter.on(Events.CloseCustomizer, this.closeCustomizer);
    }

    componentDidMount() {
        // let layoutMode = cookies.get("LayoutMode");
        let layoutMode = cookieService.getElectronCookies('LayoutMode')
        // let layoutMode = "layout-light";

        if (layoutMode?.toString() === "layout-dark") {
            this.setState({ darklayout: true });
        }

        // let res = cookies.get("compactMenu");

        // if (res !== undefined && res !== null && res?.toString() === "false") {
        //     this.props.handleCollapsedSidebar(false);
        //     this.setState({ compactMenu: false });
        // } else {
        //     this.props.handleCollapsedSidebar(true);
        //     this.setState({ compactMenu: true });
        // }
    }
    toggleCustomizer = () => {
        this.setState({
            customizer: !this.state.customizer,
        });
    };

    closeCustomizer = () => {
        this.setState({
            customizer: false,
        });
    };


    handleSizeChange = (size: string) => {
        this.props.handleSidebarSize(size);
    };

    handleLayout = (layout: string) => {
        this.props.handleLayout(layout);
    };

    // handleSidebarChange = (state: boolean) => {
    //     cookies.set("compactMenu", state);
    //     this.setState({ compactMenu: state });
    //     this.props.handleCollapsedSidebar(state);
    // };

    handleDarkMode = (e) => {
        if (e.target.checked === true) {
            this.setState({ darklayout: true });
            this.handleLayout("layout-dark");
            this.persistLayout("layout-dark");
        } else {
            this.setState({ darklayout: false });
            this.handleLayout("layout-light");
            this.persistLayout("layout-light");
        }
    };

    persistLayout = (value) => {
        // cookies.set("LayoutMode", value);
        cookieService.setElectronCookies("LayoutMode", value)
        this.setState({ darklayout: !this.state.darklayout });
        EventEmitter.emit(Events.changelayOutMode, value);
    };

    onCollapsedSideBar = () => {
        this.setState({ compactMenu: true });
    };

    render() {
        return (
            <div className={`customizer border-left-blue-grey border-left-lighten-4 ` + (this.state.customizer === true ? `open` : ``)}>

                <PerfectScrollbar>
                    <span className="customizer-toggle" id="customizer-toggle-icon" onClick={this.toggleCustomizer}>
                        <i className="fa-regular fa-circle-xmark"></i>
                    </span>
                    <div className="customizer-content">
                        <h5 className="text-uppercase">{t('customiseComponent.header')}</h5>
                        <p>{t('customiseComponent.message')}</p>
                        <hr className="my-3" />

                        <h6 className="text-center text-bold-500 mb-3 text-uppercase">{t('customiseComponent.SidebarColor')}</h6>
                        <div className="cz-bg-color">
                            <div className="row p-1">
                                <div className="col-3">
                                    <span
                                        className="bg-grey d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("white")}
                                    />
                                </div>
                                <div className="col-3">
                                    <span
                                        className="bg-blue d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("blue")}
                                    />
                                </div>
                                {/* <div className="col">
                                    <span
                                        className="gradient-pomegranate d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("pomegranate")}
                                    />
                                </div> */}

                                {/* <div className="col">
                                    <span
                                        className="gradient-ibiza-sunset d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("ibiza-sunset")}
                                    />
                                </div> */}
                                <div className="col-3">
                                    <span
                                        className="gradient-flickr d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("flickr")}
                                    />
                                </div>
                                <div className="col-3">
                                    <span
                                        className="gradient-purple-bliss d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("purple-bliss")}
                                    />
                                </div>


                            </div>
                            <div className="row p-1">
                                <div className="col-3">
                                    <span
                                        className="gradient-purple-love d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("purple-love")}
                                    />
                                </div>
                                {/* <div className="col-3">
                                    <span
                                        className="gradient-man-of-steel d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("man-of-steel")}
                                    />
                                </div> */}
                                <div className="col-3">
                                    <span
                                        className="gradient-king-yna d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("king-yna")}
                                    />
                                </div>
                                {/* <div className="col-3">
                                    <span
                                        className="bg-black d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("black")}
                                    />
                                </div> */}

                                <div className="col-3">
                                    <span
                                        className="bg-purple d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("purple")}
                                    />
                                </div>
                                {/* <div className="col">

                                    <span
                                        className="bg-red d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("red")}
                                    />
                                </div> */}
                                {/* <div className="col">
                                    <span
                                        className="bg-orange d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("orange")}
                                    />
                                </div> */}
                                <div className="col-3">
                                    <span
                                        className="bg-indigo d-block rounded-circle"
                                        style={circleStyle}
                                        onClick={() => this.props.sidebarBgColor("navy-blue")}
                                    />
                                </div>
                            </div>
                        </div>
                        <hr className="my-3" />
                        <div>
                            <Form>
                                <div className="togglebutton">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="cz-bg-image-display"
                                                checked={this.state.darklayout ? true : false}
                                                onChange={(e) => this.handleDarkMode(e)}
                                            />{" "}
                                          {t('customiseComponent.Dark Mode')}</Label>
                                    </FormGroup>
                                </div>

                                {/* <hr className="my-3" />

                                <div className="togglebutton">
                                    <FormGroup check>
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                id="cz-bg-image-display1"
                                                checked={this.state.compactMenu}
                                                onChange={(e) => {
                                                    if (e.target.checked === true) {
                                                        this.handleSidebarChange(true);
                                                    } else {
                                                        this.handleSidebarChange(false);
                                                    }
                                                }}
                                            />{" "}
                                            Compact Menu
                                        </Label>
                                    </FormGroup>
                                </div>

                                <hr className="my-3" /> */}

                                <div className="d-none">
                                    <FormGroup>
                                        <Label for="largeSelect">{t('customiseComponent.Sidebar Width')}</Label>
                                        <Input
                                            type="select"
                                            id="sidebarWidth"
                                            name="sidebarWidth"
                                            defaultValue="sidebar-md"
                                            onChange={(e) => this.handleSizeChange(e.target.value)}
                                        >
                                            <option value="sidebar-sm">{t('customiseComponent.Small')}</option>
                                            <option value="sidebar-md">{t('customiseComponent.Medium')}</option>
                                            <option value="sidebar-lg">{t('customiseComponent.Large')}</option>
                                        </Input>
                                    </FormGroup>
                                </div>
                            </Form>
                        </div>
                    </div>
                </PerfectScrollbar>
            </div>
        );
    }
}

export default Customizer;
